module.exports = __webpack_public_path__ + "img/ca0887b.svg";